import { render } from "./Calc.vue?vue&type=template&id=fbb185d2&scoped=true"
import script from "./Calc.vue?vue&type=script&lang=js"
export * from "./Calc.vue?vue&type=script&lang=js"

import "./Calc.vue?vue&type=style&index=0&id=fbb185d2&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbb185d2"]])

export default __exports__